<template>
    <div>
        <b-col cols="12">
            <video ref="video" autoplay class="camera-video" :width="w" :height="h"></video>
            <canvas ref="canvas" :width="w" :height="h" style="display: none;"></canvas>
        </b-col>
        <b-col cols="12" class="mt-2">
            <b-select
                text-field="label"
                value-field="deviceId"
                :options="devices"
                :value="selectedDevice"
                @change="changeDevice"
            ></b-select>
        </b-col>
    </div>
</template>
<script>
import { cookies } from '../../../js/mixins';
export default {
    mixins: [cookies],
    props: {
        ratio: {
            type: String,
            validator: val => ['4:3', '1:1'].includes(val),
            default: '4:3',
        },
        width: {
            type: Number,
            default: 500,
        },
        autoPlay: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        video: null,
        canvas: null,
        context: null,
        w: '',
        h: '',
        devices: [],
        selectedDevice: '',
    }),
    computed: {
        cameraSupported() {
            return 'mediaDevices' in navigator
        },
    },
    methods: {
        async on() {
            try {
                if (!this.cameraSupported) return

                const constraints = {
                    video: {
                        deviceId: this.selectedDevice
                    },
                }
                const stream  = await navigator.mediaDevices.getUserMedia(constraints)
                this.video.srcObject = stream
            } catch (error) {
                toast.error('Ocurrió un error al inicializar la cámara')
            }
        },
        off() {
            if (!this.video.srcObject) return
            this.video.srcObject.getVideoTracks().forEach(track => track.stop())
        },
        shoot() {
            this.context.drawImage(this.video, 0, 0, this.w, this.h)
            this.off()
            const imgUrl = this.canvas.toDataURL('image/png')
            this.$emit('input', imgUrl)
        },
        getDimensions() {
            return {
                width: this.canvas.width,
                height: this.canvas.height,
                aspectRatio: this.canvas.width / this.canvas.height,
            }
        },
        calculateSize() {
            const parts = this.ratio.split(':')
            const w = parts[0]
            const h = parts[1]

            const ratio = w / h
            this.w = this.width
            this.h = this.width / ratio
        },
        changeDevice(deviceId) {
            this.selectedDevice = deviceId;
            this.setDefaultCam(deviceId);
            this.off();
            this.on();
        },
        setDefaultCam(deviceId){
            this.setCookie('_vecindapp_default_cam_', deviceId);
        },
        async loadDevices() {
            if(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return
            const devices = await navigator.mediaDevices.enumerateDevices()
            this.devices = devices.filter(item => item.kind === 'videoinput').map((item, index) => ({ deviceId: item.deviceId, label: item.label || `Camara ${index + 1}` }));
            this.selectedDevice = this.devices[0].deviceId
        }
    },
    beforeDestroy() {
        this.off()
    },
    async mounted() {
        this.video = this.$refs['video']
        this.canvas = this.$refs['canvas']
        this.context = this.canvas.getContext('2d')
        this.calculateSize()

        await this.loadDevices()
        this.autoPlay && this.on()

    },
}
</script>
<style scoped>
.camera-frame {
    display: inherit;
    border-radius: 10px;
}

.camera-small {
    width: 320px;
    max-width: 100%!important;
    height: 240px;
}

.camera-medium {
    width: 640px;
    max-width: 100%;
    height: 480px;
}

.camera-large {
    width: 1024px;
    max-width: 100%;
    height: 768px;
}

.thumbnail {
    border-radius: 3px;
}

.camera-dummy {
    border-radius: 6px;
    border: 2px dashed lightgrey;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: 'Buscar';
}
</style>
